import { formatMoney } from "Helpers/helpFunction";
import moment from "moment";

export const options = (data: any, CommnonStore: any, FilterLabel: any) => {
  const tickInterval = parseInt((data?.time.length / 7).toFixed(0))
  let series = []

  let fontSizeLabel = '12px'
  let windownWidth = 473;
  if (CommnonStore?.innerWidthScreen < 700) {
    windownWidth = 300;
    fontSizeLabel = '10px'
  }

  if (FilterLabel.length === 0 || FilterLabel.indexOf('Cá nhân') > -1) {
    series.push({
      type: 'column',
      name: 'Cá nhân',
      data: data?.individual,
      color: '#22AB24',
      borderWidth: 0,
      yAxis: 0,
      marker: {
        lineWidth: 0,
      },
    })

  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Tổ chức trong nước') > -1) {
    series.push({
      type: 'column',
      name: 'Tổ chức trong nước',
      data: data?.organization_domestic,
      color: '#B8B8B8',
      borderWidth: 0,
      yAxis: 0,
      marker: {
        lineWidth: 0,
      },
    })
  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Tổ chức nước ngoài') > -1) {
    series.push({
      type: 'column',
      name: 'Tổ chức nước ngoài',
      data: data?.organization_foreign,
      color: '#F7931A',
      borderWidth: 0,
      yAxis: 0,
      marker: {
        lineWidth: 0,
      },
    })
  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('VN Index') > -1) {
    series.push({
      name: 'VN Index',
      type: 'spline',
      data: data?.vnindex,
      color: '#E31E4D',
      yAxis: 1,
      marker: {
        lineColor: '#E31E4D',
        lineWidth: 1,
        fillColor: '#ffffff'
      },
      labels: {
        marker: {
          fillColor: '#ff0000'
        }
      }
    })
  }

  return {
    chart: {
      backgroundColor: 'transparent',
      zoomType: 'xy',
      height: windownWidth,
      spacingLeft: 0,
      spacingRight: 0
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: data?.time,
      tickInterval: tickInterval,
      labels: {
        enabled: CommnonStore?.innerWidthScreen > 700,
        style: {
          color: '#B8B8B8',
          fontSize: fontSizeLabel
        }
      },
      title: {
        text: ''
      },
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
    },
    yAxis: [{
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      gridLineColor: '#4D4D4D',
      minorGridLineWidth: 0,
      lineWidth: 0,
      title: {
        enabled: CommnonStore?.innerWidthScreen > 700,
        text: 'Tỷ VNĐ',
        style: {
          color: '#B8B8B8',
          fontSize: fontSizeLabel
        }
      },
      labels: {
        enabled: CommnonStore?.innerWidthScreen > 700,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel
        },
        formatter: function (res: any) {
          const condition = 1000000000
          return formatMoney((parseFloat(res?.value) / condition).toString());
        }
      }
    }, {
      gridLineWidth: 1,
      gridLineColor: '#4D4D4D',
      opposite: true,
      title: {
        enabled: CommnonStore?.innerWidthScreen > 700,
        text: 'VN Index',
        style: {
          color: '#B8B8B8',
          fontSize: fontSizeLabel
        }
      },
      labels: {
        x: 0,
        padding: 0,
        enabled: CommnonStore?.innerWidthScreen > 700,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel
        },
        formatter: function (res: any) {
          return formatMoney(res?.value);
        }
      }
    }],
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      },
      series: {
        // states: {
        //   inactive: {
        //     opacity: 1
        //   }
        // }
      }
    },
    accessibility: {
      enabled: false
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function (item: any) {
        const thisData: any = this
        const index: any = thisData.point.index
        const condition = 1000000000
        const name = thisData?.series?.name

        let time = null
        const firstday = data?.timestamp?.[index]?.firstday;
        const lastday = data?.timestamp?.[index]?.lastday;

        if (data?.timestamp?.[index]) {
          if (firstday === lastday) {
            time = moment(firstday).format('DD/MM/YYYY');
          } else if (firstday && lastday) {
            time = `${moment(firstday).format('DD/MM/YYYY')} - ${moment(lastday).format('DD/MM/YYYY')}`
          }
        }

        const dv = CommnonStore?.innerWidthScreen > 700 ? `` : 'Tỷ VNĐ'

        return `<div class="ioalomryco">
        ${firstday !== lastday ? `<div class="fzlgnzcgwl whlqpruvka"><b>${data?.time[index]}</b></div>` : ''}
        <div class="fzlgnzcgwl fzbjtfpdgt"><b>${time}</b></div>
        <div class="fzlgnzcgwl fzbjtfpdgt" style="${name === 'Cá nhân' ? 'font-weight: bold;' : ''}">Cá nhân: <span style="color: ${data?.individual[index] > 0 ? '#2AD03D' : '#E31E4D'}">${formatMoney((parseFloat(data?.individual[index]) / condition).toString(), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt" style="${name === 'Tổ chức trong nước' ? 'font-weight: bold;' : ''}">Tổ chức trong nước: <span style="color: ${data?.organization_domestic[index] > 0 ? '#2AD03D' : '#E31E4D'}">${formatMoney((parseFloat(data?.organization_domestic[index]) / condition).toString(), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt" style="${name === 'Tổ chức nước ngoài' ? 'font-weight: bold;' : ''}">Tổ chức nước ngoài: <span style="color: ${data?.organization_foreign[index] > 0 ? '#2AD03D' : '#E31E4D'}">${formatMoney((parseFloat(data?.organization_foreign[index]) / condition).toString(), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt" style="${name === 'VN Index' ? 'font-weight: bold;' : ''}">VN Index: <span style="color: ${data?.vnindex[index] > 0 ? '#2AD03D' : '#E31E4D'}">${formatMoney(data?.vnindex[index], 2)}</span></div>
        </div>`;
      }
    },
    series: series
  }
}